/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css } from "@panda/css";

const dividerStyles = css({
	width: "1px",
	borderInlineStartWidth: "1px",
	borderInlineStartStyle: "solid",
	borderInlineStartColor: "eds.border.subtle",
	transform: "translateZ(0)",
	xsOnly: {
		width: "100%",
		height: "1px",
		borderTopWidth: "1px",
		borderTopStyle: "solid",
		borderTopColor: "eds.border.subtle",
	},
});

export const Divider = (): React.JSX.Element => {
	return <div className={dividerStyles}></div>;
};
